import React from 'react';

export function Home()
{

    return <h1>Hello World</h1>;
}